import $http from '@vue-util/http';

const fetchProductWithAnalytics = async (productId, urlParams = {}) => {
  const url = `/xapi/digital/v1/product/${productId}?${new URLSearchParams({
    ...urlParams,
  })}`;

  try {
    const { data } = await $http.get(url);
    return data;
  } catch {
    return undefined;
  }
};

export default fetchProductWithAnalytics;
